"use strict";

var _defineProperty = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/defineProperty.js");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var uuid_1 = require("uuid");

function initialState() {
  return {
    class: "income",
    type: null,
    subType: null,
    interest: null,
    disbursements: [],
    monthlyCalcMethod: null,
    itemizeInterval: null,
    // 'employment' ---
    party: null,
    occupation: null,
    startedAt: null,
    endedAt: null,
    // startedAtToEndedAt: null, // STRING - Generated on output but can provide a string if non-dates
    // 'non_employment' ---
    additionalDescription: null,
    cashBased: null // Matters at times if other gov assistance is cash/non-cash based
    // OPTIMIZE: Thinking gross incomes should just extend from income obj
    // gross: {
    //   2017: 0,
    //   2018: 200,
    // },

  };
} // @ts-expect-error


var createIncome = function createIncome(attrs) {
  return _objectSpread(_objectSpread(_objectSpread({}, initialState()), attrs), {}, {
    id: (0, uuid_1.v4)()
  });
};

exports.default = createIncome;